import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { FormLabel, FormControl, Input, SimpleGrid } from 'components/UI';
import { Formik } from 'formik';
import { validateForm } from 'utils/helpers';
import { validateRequired } from 'utils/validation';
import ButtonProc, { ButtonProcProps } from '../Buttons/ButtonProc';

export interface BomFormValues {
  projectNumber: string;
  quantity: string;
}

type BomFormProps = {
  onSubmit: (values: BomFormValues) => void;
  buttonProps?: Omit<ButtonProcProps, 'onClick'>;
};

const BomForm = ({ onSubmit, buttonProps }: BomFormProps) => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <Formik
      initialValues={{ projectNumber: '', quantity: '' }}
      validate={async (values) => {
        const errors = validateRequired<BomFormValues | Record<string, never>>(['projectNumber', 'quantity'], values);

        return errors;
      }}
      onSubmit={onSubmit}
    >
      {(formConfig) => {
        const { values, handleChange, handleBlur, handleSubmit, isSubmitting } = formConfig;

        const formErrors = validateForm<BomFormValues>({
          ...formConfig,
          submitted,
        });

        return (
          <form onSubmit={handleSubmit}>
            <SimpleGrid columns={1} spacing={1} mb={4}>
              <Box>
                <FormLabel htmlFor="projectNumber">Project Number</FormLabel>

                <FormControl isInvalid={!!formErrors.projectNumber} mb={2}>
                  <Input
                    type="text"
                    name="projectNumber"
                    maxLength={20}
                    value={values.projectNumber}
                    error={formErrors.projectNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    placeholder="Enter the project number"
                  />
                </FormControl>
              </Box>

              <Box>
                <FormLabel htmlFor="quantity">Quantity</FormLabel>

                <FormControl isInvalid={!!formErrors.quantity}>
                  <Input
                    type="text"
                    name="quantity"
                    maxLength={4}
                    value={values.quantity}
                    error={formErrors.quantity}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    placeholder="Enter the quantity"
                  />
                </FormControl>
              </Box>
            </SimpleGrid>
            <ButtonProc
              isDisabled={isSubmitting}
              isLoading={isSubmitting}
              onClick={() => setSubmitted(true)}
              type="submit"
              size="sm"
              sx={{ w: 'full', mt: 4, ...(buttonProps?.sx ?? {}) }}
              first="SUBMIT"
              {...buttonProps}
            />
          </form>
        );
      }}
    </Formik>
  );
};

export default BomForm;
